import { render, staticRenderFns } from "./passageLog.vue?vue&type=template&id=dde35bda&scoped=true"
import script from "./passageLog.vue?vue&type=script&lang=js"
export * from "./passageLog.vue?vue&type=script&lang=js"
import style0 from "./passageLog.vue?vue&type=style&index=0&id=dde35bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde35bda",
  null
  
)

export default component.exports